/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { SmsTemplateDetailsDto, SmsTemplateListItemDto, TemplatePlaceholderDto } from '@gh/builder-shared-data';

export type SmsTemplateListItem = SmsTemplateListItemDto;
export type SmsTemplateDetails = SmsTemplateDetailsDto;
export type SmsPlaceholder = TemplatePlaceholderDto;

export const newSmsTemplateDetails = (): SmsTemplateDetails => <SmsTemplateDetails>({
  name: '',
  description: '',
  body: '',
});
